const dialogOpeners = new WeakMap();
const syncDialogScroll = () => {
  document.body.style.overflow = document.querySelector('dialog[open]') ? 'hidden' : '';
};

document.querySelectorAll('[data-open]').forEach(button => {
  button.addEventListener('click', () => {
    const dialog = document.getElementById(button.dataset.open);
    if (!dialog || dialog.open) return;
    dialogOpeners.set(dialog, button);
    dialog.showModal();
    syncDialogScroll();
    dialog.querySelector('[data-close]')?.focus({ preventScroll: true });
  });
});

document.querySelectorAll('dialog').forEach(dialog => {
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || event.target.closest('dialog') !== dialog) return;
    const controls = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter(control => control.getClientRects().length && control.closest('dialog') === dialog);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', event => {
    if (event.target !== dialog) return;
    syncDialogScroll();
    const opener = dialogOpeners.get(dialog);
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
});

document.querySelectorAll('[data-close]').forEach(button => {
  button.addEventListener('click', () => button.closest('dialog')?.close());
});

document.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
  const media = button.closest('.media');
  const image = media.querySelector('[data-view-image]');
  image.src = button.dataset.image; image.alt = button.dataset.alt;
  media.querySelectorAll('[data-image]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
}));

// The group card previews studio photos; each gallery choice retains its own product dialog.
document.querySelectorAll('[data-imperfectionst-card]').forEach(card => {
  const images = [...card.querySelectorAll('[data-imperfectionst-preview]')];
  const status = card.querySelector('[data-imperfectionst-status]');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let requested = 0;
  if (!images.length) return;

  const select = (index, announce = false) => {
    index = Math.max(0, Math.min(images.length - 1, index));
    requested = index;
    const next = images[index];
    const display = () => {
      if (requested !== index) return;
      images.forEach((image, imageIndex) => { image.hidden = imageIndex !== index; });
      card.dataset.previewHandle = next.dataset.handle;
      if (announce && status) status.textContent = `${next.dataset.title}, ${index + 1} of ${images.length}`;
    };
    if (next.complete && next.naturalWidth) display();
    else {
      next.loading = 'eager';
      next.addEventListener('load', display, { once: true });
    }
  };
  const preload = () => images.forEach(image => { image.loading = 'eager'; });
  card.dataset.previewHandle = images[0].dataset.handle;
  card.addEventListener('pointerenter', event => {
    if (event.pointerType === 'mouse' && finePointer.matches) preload();
  });
  card.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse' || !finePointer.matches || images.length < 2) return;
    const bounds = card.getBoundingClientRect();
    if (!bounds.width) return;
    const index = Math.floor((event.clientX - bounds.left) / bounds.width * images.length);
    if (Math.max(0, Math.min(images.length - 1, index)) !== requested) select(index);
  });
  card.addEventListener('pointerleave', () => select(0));
  card.addEventListener('focus', preload);
  card.addEventListener('blur', () => select(0));
  card.addEventListener('keydown', event => {
    let index;
    if (event.key === 'ArrowRight') index = (requested + 1) % images.length;
    else if (event.key === 'ArrowLeft') index = (requested + images.length - 1) % images.length;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = images.length - 1;
    else return;
    event.preventDefault();
    select(index, true);
  });
});

document.querySelectorAll('[data-imperfectionst-grid]').forEach(grid => {
  const choices = [...grid.querySelectorAll('[data-open]')];
  grid.addEventListener('keydown', event => {
    const current = choices.indexOf(document.activeElement);
    if (current < 0) return;
    let index;
    if (event.key === 'ArrowRight') index = (current + 1) % choices.length;
    else if (event.key === 'ArrowLeft') index = (current + choices.length - 1) % choices.length;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = choices.length - 1;
    else return;
    event.preventDefault();
    choices[index].focus();
  });
});
